<template>
  <div>
    datatable page
  </div>
</template>

<script>
export default {
  name: 'datatable'
}
</script>

<style lang="stylus" scoped>

</style>
